// extracted by mini-css-extract-plugin
module.exports = {"content":"DatiFormCard_content__Qzv5v","editButton":"DatiFormCard_editButton__dzSzc","rotation":"DatiFormCard_rotation__nsV3q"};